// Monthly/Yearly toggle for the credits-billing /plans page. `prices` and
// `urls` are keyed by plan checkout key (starter, pro, pro_plus), each with
// monthly/yearly values.
export default function CreditsPlans({ prices, urls }) {
  const planToggle = document.querySelector(".toggle")

  planToggle?.addEventListener("click", function (e) {
    e.preventDefault()
    this.classList.toggle("active")

    const interval = this.classList.contains("active") ? "yearly" : "monthly"

    Object.keys(prices).forEach(plan => {
      document.querySelectorAll(`a[data-plan-tier='${plan}']`).forEach(link => {
        link.setAttribute("href", urls[plan][interval])
      })

      const priceDisplay = document.querySelector(`.price-amount[data-plan-tier='${plan}']`)
      if (priceDisplay) {
        priceDisplay.innerHTML = prices[plan][interval]
      }
    })

    document.querySelectorAll(".yearly-price, .yearly-price-spacer").forEach(el => {
      el.classList.toggle("hidden")
    })
  })
}
